/**
 * Site poster template (global Storage) — project code placement on A4.
 * Upload: global/CrewchainSitePosterFinal2.pdf (Firebase Console).
 *
 * Placement coords match the design spec: origin top-left, Y increases downward
 * (same as HTML/CSS). pdf-lib uses bottom-left — convert via sitePosterYFromTopToPdfLib.
 */

export const SITE_POSTER_STORAGE_PATH = 'global/CrewchainSitePosterFinal2.pdf';

/** A4 — matches designed poster PDF */
export const SITE_POSTER_PAGE_PT = { width: 595.5, height: 842.25 };

/** Empty bottom area (top-left origin: y down from page top) */
export const SITE_POSTER_CODE_BOX_PT = {
  left: 95,
  top: 690,
  right: 500,
  bottom: 805,
};

export const SITE_POSTER_CODE_BOX_WIDTH_PT =
  SITE_POSTER_CODE_BOX_PT.right - SITE_POSTER_CODE_BOX_PT.left;

export const SITE_POSTER_CODE_BOX_HEIGHT_PT =
  SITE_POSTER_CODE_BOX_PT.bottom - SITE_POSTER_CODE_BOX_PT.top;

/** Centered project code — X center of page */
export const SITE_POSTER_CODE_ANCHOR_X = 297.75;
export const SITE_POSTER_CODE_FONT_SIZE_PT = 32;

/**
 * Baseline Y from page top — vertically centers glyphs in the code box (matches HTML flex
 * preview). pdf-lib drawText uses baseline, not box center (see team sign-off row layout).
 */
export function getSitePosterCodeBaselineFromTop(
  fontSizePt = SITE_POSTER_CODE_FONT_SIZE_PT,
) {
  const { top, bottom } = SITE_POSTER_CODE_BOX_PT;
  const boxCenterFromTop = (top + bottom) / 2;
  return boxCenterFromTop + fontSizePt * 0.36;
}

/** Full line stamped on poster (preview + PDF download). */
export function formatSitePosterProjectCodeLine(projectCode) {
  return `Project code : ${String(projectCode || '').trim()}`;
}

/** pdf-lib drawText: baseline Y from page bottom */
export function sitePosterYFromTopToPdfLib(yFromTop) {
  return SITE_POSTER_PAGE_PT.height - yFromTop;
}

/**
 * @param {number} scale — preview px per PDF pt
 */
export function getSitePosterCodeOverlayRectPx(scale) {
  const { left, top, right, bottom } = SITE_POSTER_CODE_BOX_PT;
  return {
    left: left * scale,
    top: top * scale,
    width: (right - left) * scale,
    height: (bottom - top) * scale,
  };
}

export function getSitePosterPreviewScale(previewWidthPx = 520) {
  return previewWidthPx / SITE_POSTER_PAGE_PT.width;
}
